import { WeightBracketPrice } from "./weight-bracket-price.model";
import { WeightBracketPriceDict } from "./weight-bracket-price-dict.type";
import { WeightBracketName } from "./weight-bracket-name.type.const";
import { WeightBracketPriceDictMapper } from "./weight-bracket-price-dict.mapper";

export class WeightBracketPrices {
  private weightBracketPriceDict = <WeightBracketPriceDict>{};

  constructor(data: WeightBracketPrice[]) {
    this.setWeightBracketPriceDict(data);
  }

  public getPrices(): WeightBracketPriceDict {
    return this.weightBracketPriceDict;
  }

  public setPrices(param: WeightBracketPriceDict) {
    this.weightBracketPriceDict = param;
  }

  public getPrice(param: WeightBracketName): number {
    return this.getPrices()[param] ? this.getPrices()[param].getValue() : null;
  }

  public setPrice(param: WeightBracketName, val: number) {
    try {
      this.getPrices()[param] = new WeightBracketPrice(param, val);
    } catch (e) {
      console.error(`can't set ${param} container with ${val} (${e})`);
    }
  }

  public getWeightBracketPriceNames(): WeightBracketName[] {
    return <WeightBracketName[]>Object.keys(this.weightBracketPriceDict);
  }

  public getRequestParams() {
    return WeightBracketPriceDictMapper.toArray(this.weightBracketPriceDict);
  }

  public hasAtLeastOnePrice(equipment: string[] = []) {
    return equipment
      .map((weightBracketName) =>
        this.weightBracketPriceDict[weightBracketName]
          ? this.weightBracketPriceDict[weightBracketName]
          : null,
      )
      .some((val) => val !== null);
  }

  private setWeightBracketPriceDict(
    data: WeightBracketPrices | WeightBracketPrice[],
  ) {
    if (data instanceof WeightBracketPrices) {
      this.weightBracketPriceDict = { ...data.getPrices() };
    }

    if (Array.isArray(data)) {
      this.weightBracketPriceDict = WeightBracketPriceDictMapper.toDict(data);
    }
  }
}
